import { render, staticRenderFns } from "./AffectedProjects.vue?vue&type=template&id=4182a304&"
import script from "./AffectedProjects.vue?vue&type=script&lang=js&"
export * from "./AffectedProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4182a304')) {
      api.createRecord('4182a304', component.options)
    } else {
      api.reload('4182a304', component.options)
    }
    module.hot.accept("./AffectedProjects.vue?vue&type=template&id=4182a304&", function () {
      api.rerender('4182a304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/vulnerabilities/AffectedProjects.vue"
export default component.exports